import React from 'react';
import { Tabs } from 'antd';
import { Container } from './styles';
import Instructions from './Instructions';
import InspectionOptions from './Options';
import InspectionIssues from './Issues';

export default function InspectionSettings() {
  const items = [
    {
      label: 'Instructions',
      key: '1',
      children: <Instructions />,
      // children: <Table dataSource={instructions} columns={columns} size="small" pagination={false} rowKey="field" />,
    },
    {
      label: 'Options',
      key: '2',
      children: <InspectionOptions />,
    },
    {
      label: 'Known Issues',
      key: '3',
      children: <InspectionIssues />,
    },
  ];

  return (
    <Container>
      <Tabs defaultActiveKey="1" type="card" tabBarStyle={{ fontWeight: 'bold' }} items={items} />
    </Container>
  );
}
